<template>
	<div class="login-page">
		<div class="container">
			<div class="row">
				<div class="col-12 col-sm-9 col-md-7 col-lg-5 m-auto pt-5">
					<div class="card mt-5">
						<div class="card-header bg-white">
							<h3 class="text-center mb-0 text-secondary">{{$conf.logo}}</h3>
						</div>
						<div class="card-body">
							<el-form ref="ruleform" :model="form" :rules="rules">
								<el-form-item prop="username">
									<el-input v-model="form.username" size="medium" placeholder="登錄賬號 ">
										<i slot="prefix" class="el-input__icon el-icon-user"></i>
									</el-input>
								</el-form-item>
								<el-form-item prop="password">
									<el-input v-model="form.password" type="password" size="medium" placeholder="登錄密碼">
										<i slot="prefix" class="el-input__icon el-icon-key"></i>
									</el-input>
								</el-form-item>
								
								<!-- <el-form-item prop="googleCode">
									<el-input v-model="form.googleCode" size="medium" placeholder="谷歌驗證碼 ">
										<i slot="prefix" class="el-icon-paperclip"></i>
									</el-input>
								</el-form-item> -->

								<el-form-item prop="code">
									<el-input v-model="form.code" style="width: 50%;" type="text" size="medium" placeholder="驗證碼">
										<i slot="prefix" class="el-input__icon el-icon-refresh"></i>
									</el-input>
									<div style="width: 45%;float: right;margin-left: 5%; " @click="refreshCode()">
										<v-sidentify ref="childRef"  :identifyCode="identifyCode" :styleOptions="{ letterSpacing: '10px', rotateRange: 5 }"></v-sidentify>
									</div>
								</el-form-item>
								
								<el-form-item>
									<el-button @click="submit" :loading="loading" type="primary" size="medium" class="w-100">
										{{loading?'登錄....':'登錄'}}
									</el-button>
								</el-form-item>
								<p style="font-size: 11px;text-align: center;">Powered by Spankers EduTech Company Ltd. All rights reserved.</p>
							</el-form>
						</div>
						<div class="card-footer">

						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	
	import {Decrypt,Encrypt} from '@/common/aes/utils.js'
	import Sidentify from '@/components/common/Sidentify.vue';
	import {
		mapGetters
	} from 'vuex';
	export default {
		components: {
			'v-sidentify': Sidentify
		},
		data() {
			return {
				identifyCodes: '123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ',
				identifyCode: '',
				img: '',
				loading: false,
				form: {
					username: "",
					password: "",
					googleCode: "",
					code: "",
					coo:"",
					data:""
				},
				rules: {
					username: [{
						required: true,
						message: "請輸入登錄賬號",
						trigger: "blur"
					}],
					password: [{
						required: true,
						message: "請輸入登錄密碼",
						trigger: "blur"
					}],
					
					// googleCode: [{
					// 	required: true,
					// 	message: "請輸入谷歌驗證碼",
					// 	trigger: "blur"
					// }],
					code: [{
						required: true,
						message: "請輸入驗證碼",
						trigger: "blur"
					}]
				}
			}
		},
		computed: {
			...mapGetters([
				'adminIndex'
			])

		},
		mounted() {
			this.identifyCode = ''
			this.makeCode(this.identifyCodes, 4)
			
			// 添加全局的键盘事件监听器
			window.addEventListener('keydown', this.handleKeydown);
		},
		beforeDestroy() {
		    // 移除全局的键盘事件监听器
		    window.removeEventListener('keydown', this.handleKeydown);
		  },
		created() {
			//this.getCaptcha()
		},
		methods: {
			handleKeydown(event) {
			  if (event.key === 'Enter') {
				//console.log('Enter key pressed');
				// 这里可以添加你的逻辑，例如提交表單或进行其他操作
				//alert('You pressed Enter');
				this.submit()
			  }
			},
			randomNum(min, max) {
				return Math.floor(Math.random() * (max - min) + min)
			},
			refreshCode() {
				this.identifyCode = ''
				
				this.makeCode(this.identifyCodes, 4)
			},
			makeCode(o, l) {
				for (let i = 0; i < l; i++) {
					this.identifyCode += this.identifyCodes[
						this.randomNum(0, this.identifyCodes.length)
					]
				}
				this.identifyCode = Encrypt(this.identifyCode)
				this.form.coo = this.identifyCode
				this.form.data = Encrypt(this.randomNum(100,999)+ Math.random())
			},
			// getCaptcha() {
			// 	this.img = this.img + Math.random(); //给图片地址配一个无用的随机數
			// },
			submit() {
				let b = this.$route
				//let timestamp = new Date().getTime();
				this.$refs.ruleform.validate((e) => {
					if (!e) return;
					// 提交表單

					this.loading = true
					this.axios.post('/admin/user/login',
						this.form
					).then(res => {
						//console.log(res);
						// if(res.data.encryption.code!=1){
						// 	this.$message.error(res.data.encryption.msg);
						// }
						
						if (res.data.code == 1) {
							let info = res.data.data.list

							//存储到vuex
							console.log(info)
						
							
							// 存储到本地
							this.$store.commit('login', info)

							// 存储权限规则
							if (info.role && info.role.rules) {
								window.sessionStorage.setItem('rules', JSON.stringify(info.role.rules))
							}
							console.log(1);

							// 生成後台菜單
							this.$store.commit('createNavBar', info.tree)
							console.log(2);
							// 成功提示
							this.$message('登錄成功');

							this.loading = false
							// 跳转到首頁
							this.$router.push({
								name: this.adminIndex
							})
						} else {
							this.refreshCode()
							this.loading = false
						}

					}).catch(err => {
						this.refreshCode()
						this.loading = false
						//console.log(err.response);
					})
					//this.$router.push({name:'index'})
				})
			}
		}
	}
</script>

<style scoped>
	.login-page {
		position: relative;
		min-height: 100vh;
		background: url('./background.jpg') no-repeat center center fixed;
		background-size: cover;
	}
</style>